import React, { useCallback, useMemo } from 'react'

import ButtonIcon from '../../../../../../../features/components/Buttons/ButtonIcon'
import { ReactComponent as ShareIcon } from '../../../../../../../assets/icons/share-icon.svg'

import useStyles from './styles'

function FacebookPost({ post, isSelected, onClick }) {
  const classes = useStyles({ isSelected })

  const { id, picture, message, permalink_url: permalinkUrl } = post

  const formattedId = useMemo(() => {
    return id?.split('_')?.[1]
  }, [id])

  const shareLinkHandler = useCallback(e => {
    e.stopPropagation()
  }, [])

  return (
    <div onClick={onClick} className={classes.facebookPost}>
      <div className={classes.previewArea}>
        {picture && <img className={classes.preview} src={picture} alt={'post'} />}
      </div>
      <div className={classes.body}>
        <div className={classes.postId}>Post ID: {formattedId}</div>
        {!!message && <p className={classes.postText}>{message}</p>}
      </div>
      <a href={permalinkUrl} target="_blank" rel="noreferrer" onClick={shareLinkHandler}>
        <ButtonIcon className={classes.shareBtn} Icon={ShareIcon} />
      </a>
    </div>
  )
}

export default FacebookPost
